<template>
  <div>
    <el-card class="box-card" shadow="never" style="overflow: visible">

      <div slot="header" class="clearfix">
        <span style="color:#1c6f6e;font-size: 16px;font-weight: bold;">基础信息</span>
        <router-link v-if="!GET_USER_INFO.phone" to="/user/account" style="color: #fa5c5c" target="_blank">【发布前请先绑定手机号】
        </router-link>
      </div>

      <el-form :model="ruleForm" :rules="rules" :disabled="!GET_USER_INFO.phone" ref="ruleForm" label-width="100px"
        class="demo-ruleForm">
        <el-form-item label="上传方式" prop="uploadType">
          <el-select v-model="ruleForm.uploadType" placeholder="请选择软件" style="width: 300px">
            <el-option label="文件上传" value="1">
              文件上传
              <span style="color: #adadad; font-size: 12px; padding-left: 10px">(推荐使用)</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="ruleForm.uploadType == 1">
          <template slot="label">
            <span style="color: #f56c6c">*</span> 资产上传
          </template>
          <!-- 上传遮罩 -->
          <div class="mUpload-box">
            <div v-if="fileLoading" class="mUpload-mask"></div>
            <el-upload name="file" class="upload-demo" :disabled="!GET_USER_INFO.phone" :on-preview="downLoad"
              :multiple="true" :show-file-list="true" :action="UPLOAD_FILE_URL" :headers="uploadHeader"
              :before-upload="beforeFileUpload" :before-remove="beforeFileRemove" :on-remove="handleFileRemove"
              :http-request="handleFileSuccess" :on-progress="handleFileProgress" :file-list="ruleForm.fileList"
              :limit="20">
              <el-button :loading="fileLoading" :disabled="!GET_USER_INFO.phone"
                :title="GET_USER_INFO.phone ? '' : '【请先绑定手机】'" size="small" type="danger" plain>
                {{ fileLoading ? "上传中" : "点击上传" }}
              </el-button>

              <div slot="tip" style="display: inline-block;
                  vertical-align: top;
                  margin: 0 0 0 10px;" class="el-upload__tip">
                *请仔细阅读
                <el-popover placement="right" :width="400" trigger="click">
                  <template #reference>
                    <a class="specification" :style="{ cursor: 'pointer' }">《模型上传规范》</a>
                  </template>
                  <div>
                    <p>
                      <b><span>模型上传规范</span></b><b><span></span></b>
                    </p>
                    <p>
                      <span><span>文件格式：目前支持大部分</span><span>3D</span><span>软件格式，如提示无法上传，请将其打包为</span><span>.zip</span><span>或者</span><span>.rar</span><span>格式后上传。</span></span><span></span>
                    </p>
                    <p>
                      <span>上传的单个文件建议小于1G(1024M)，若上传大文件时（超过1G）可能会出现超时而导致上传失败的问题，请检查网络状态（上传速度）或选择分卷压缩包上传！</span><span></span>
                    </p>
                    <p>
                      <b><span>模型</span></b><b><span>格式推荐</span></b><b>:</b><b><span></span></b>
                    </p>
                    <p>
                      <span>建议上传多种格式模型，以增加兼容性，</span><span>方便其他用户购买使用，</span><span><span>推荐上传</span><span>.max,.ma,.blender,.c4d,.fbx,obj</span><span>等多种格式</span></span><span></span>
                    </p>
                    <p>
                      <b><span>贴图</span></b><b><span>推荐</span></b><b>:</b><b><span></span></b>
                    </p>
                    <p>
                      <span><span>多个贴图推荐打包</span><span>.zip,.rar</span><span>压缩包格式上传方便下载</span></span><span></span>
                    </p>
                    <p>
                      <b><span>贴图</span></b><b><span>命名规则</span></b><b><span>推荐</span></b><b>:</b><b><span></span></b>
                    </p>
                    <p>
                      <span>1.&nbsp;</span><span><span>贴图命名推荐</span><span>SoMo</span></span><span>_[</span><span>物体名称</span><span>]_</span><span><span>[</span><span>物体部位</span><span>]_[</span><span>贴图通道</span><span>]</span></span><span></span>
                    </p>
                    <p>
                      <span><span>例如：</span><br><span>&nbsp;&nbsp;柳树树干颜色贴图命名</span>
                        <span>SoMo_Willow0016_Bark_</span></span><span>BaseColor</span><span>&nbsp;</span><span></span>
                    </p>
                    <p>
                      <span>&nbsp;&nbsp;</span><span><span>柳树树干法线贴图命名</span>
                        <span>SoMo_Willow0016_Bark_</span></span><span>Normal</span><span></span>
                    </p>
                    <p>
                      <span>2.&nbsp;</span><span><span>压缩文件命名：</span><span>[</span><span>名称</span><span>][</span><span>质量</span><span>]by_[</span><span>作者</span><span>].zip</span></span><span></span>
                    </p>
                    <p>
                      <span><span>示例：</span><span>car_4K_by_zhangsan.zip</span></span><span></span>
                    </p>
                    <p>
                      <span><span>3</span></span><span><span>.
                        </span><span>保证贴图、模型资产等完整，不能有丢失贴图等情况。</span></span><span></span>
                    </p>
                    <p>
                      <span><span>4</span></span><span><span>.</span></span><span>&nbsp;</span><span>请严格遵守国家相关法规，不上传违法内容</span><span></span>
                    </p>
                  </div>
                </el-popover>


              </div>
            </el-upload>
          </div>
        </el-form-item>

        <template v-else-if="ruleForm.uploadType == 2">
          <el-form-item label="网盘地址" key="netDisk" :prop="'netDisk'" :rules="[
            { required: true, message: '请输入网盘地址', trigger: 'blur' },
          ]">
            <el-input v-model="ruleForm.netDisk" style="width: 400px" placeholder="请填写网盘地址"></el-input>
          </el-form-item>
          <el-form-item label="提取码" key="netDiskCode" :prop="'netDiskCode'" :rules="[
            { required: true, message: '请输入提取码', trigger: 'blur' },
          ]">
            <el-input v-model="ruleForm.netDiskCode" style="width: 400px" placeholder="请填写提取码"></el-input>
          </el-form-item>
        </template>

        <el-form-item label="标题" prop="title" key="title">
          <el-input v-model="ruleForm.title" style="width: 400px" placeholder="标题长度不超过32个汉字"
            @mouseover.native="titleHover = true" @mouseleave.native="titleHover = false"></el-input>
          <span v-if="titleHover"> 例如：桌子 木桌 方桌 办公桌····</span>
        </el-form-item>

        <el-form-item label="面数" prop="surfaceNum" key="surfaceNum">
          <el-input-number v-model="ruleForm.surfaceNum" controls-position="right" placeholder="请填写面数"
            class="user-resource-inputNum" style="width: 400px"></el-input-number>
        </el-form-item>

        <el-form-item label="点数" prop="pointNum" key="pointNum">
          <el-input-number v-model="ruleForm.pointNum" controls-position="right" placeholder="请填写点数"
            class="user-resource-inputNum" style="width: 400px"></el-input-number>
        </el-form-item>

        <el-form-item label="属性" prop="includeIdList" key="includeIdList">
          <el-checkbox-group v-model="ruleForm.includeIdList">
            <el-checkbox v-for="item in includeIdList" :key="item.id" :label="item.id" name="includeIdList">
              {{ item.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item key="headImageList">
          <template slot="label">
            <span style="color: #f56c6c">*</span> 首图
          </template>
          <ul class="img-list">
            <draggable class="vue-draggable" :class="{ single: true, maxHidden: false }" v-model="ruleForm.headImageList"
              tag="ul" draggable=".draggable-item" @start="onDragStart" @end="onDragEnd">
              <!-- 拖拽元素 -->
              <li class="img-item draggable-item" v-for="item in ruleForm.headImageList" :key="item.imageId">
                <img class="el-upload-list__item-thumbnail" :src="linkAllImgUrl(item.url)" />
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-delete shadow" @click="handleHeadImgRemove(item)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </li>
              <ImgCutter v-on:cutDown="cutDown" v-if="ruleForm.headImageList.length < 1" :sizeChange="false"
                :boxWidth="1200" :boxHeight="1200" :cutWidth="800" :cutHeight="800" title="请手动剪裁合适的图片大小"
                :move-able="true">
                <div slot="open" class="image-box" :title="GET_USER_INFO.phone ? '' : '【请先绑定手机】'">
                  <i slot="default" class="el-icon-plus"></i>
                </div>
              </ImgCutter>
            </draggable>
          </ul>

          <div>
            点击查看
            <el-popover placement="right" :width="400" trigger="click">
              <template #reference>
                <a class="specification" :style="{ cursor: 'pointer' }">《首图上传规范》</a>
              </template>
              <div>
                <p>
                  <b><span>首图</span></b><b><span>上传规范</span></b><b><span></span></b>
                </p>
                <p>
                  <span>为方便用户浏览，</span><span>我们建议您在制作预览图时按照如下要求进行：</span>
                </p>
                <p>
                  <span>一、第一张预览图默认作为资产的封面进行显示，</span>
                  <span>推荐渲染精美的图片，</span>
                  <span>
                    <span>格式要求为</span>
                    <span>jpg/png</span>
                    <span>。</span>
                  </span>
                </p>
                <p>
                  <span>二</span><span>、不得上传与模型资产无关或违法图片，否则不予通过。</span><span></span>
                </p>
                <p>
                  <span>三、</span><span>请严格遵守国家相关法规，不上传违法内容。</span>
                </p>
              </div>
            </el-popover>

            <span style="color: #75808f; font-size: smaller">鼠标滚轮可以缩放图片，鼠标左键拖动图片与裁剪框</span>
          </div>
        </el-form-item>


        <el-form-item key="imageList">
          <template slot="label">
            <span style="color: #f56c6c">*</span> 预览
          </template>
          <ul class="img-list">
            <draggable class="vue-draggable" :class="{ single: true, maxHidden: false }" v-model="ruleForm.imageList"
              tag="ul" draggable=".draggable-item" @start="onDragStart" @end="onDragEnd">
              <!-- 拖拽元素 -->
              <li class="img-item draggable-item" v-for="item in ruleForm.imageList" :key="item.imageId">
                <img class="el-upload-list__item-thumbnail" :src="linkAllImgUrl(item.url)" />
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-delete shadow" @click="handleImgRemove(item)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </li>
              <div class="img-container" v-loading="imgLoading">
                <el-upload name="image" :multiple="true" :disabled="!GET_USER_INFO.phone"
                  accept="image/png,image/jpg,image/jpeg" :action="UPLOAD_URL_WATER" :headers="uploadHeader"
                  :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                  :limit="24" :on-exceed="handleAvatarExceed">
                  <div class="image-box" :title="GET_USER_INFO.phone ? '' : '【请先绑定手机】'">
                    <i slot="default" class="el-icon-plus"></i>
                  </div>
                </el-upload>
              </div>
            </draggable>
          </ul>

          <div>
            点击查看
            <el-popover placement="right" :width="400" trigger="click">
              <template #reference>
                <a class="specification" :style="{ cursor: 'pointer' }">《预览图上传规范》</a>
              </template>
              <div>
                <p>
                  <b><span><span>预览</span></span></b><b><span>图</span></b><b><span>上传规范</span></b><b><span></span></b>
                </p>
                <p>
                  <span>为保证您上传的模型能够被正确展现，提升上传资产的浏览量，我们建议您在制作预览图时按照如下要求进行：</span><span></span>
                </p>
                <p>
                  <span>&nbsp;</span>
                </p>
                <p>
                  <span>一</span><span>、推荐上传预览图最少为五张，多视图以及线框图，多精美图会增加销售量。</span><span></span>
                </p>
                <p>
                  <span>二</span><span><span>、建议单张图片大小不高于</span><span>1M</span><span>，否则可能会影响用户浏览体验。</span></span><span></span>
                </p>
                <p>
                  <span>三</span><span>、不得上传与模型资产无关或违法图片，否则不予通过。</span><span></span>
                </p>
                <p>
                  <span>四</span><span>、请严格遵守国家相关法规，不上传违法内容。</span><span></span>
                </p>
              </div>
            </el-popover>

            <span style="color: #75808f; font-size: smaller"> 拖动图片可调整图片展示顺序哦，最大支持上传24张预览图</span>
          </div>
        </el-form-item>
        <!-- 富文本编辑器 -->
        <el-form-item label="描述" key="remark">
          <div ref="contentEditor"></div>
        </el-form-item>

        <el-form-item label="软件" prop="softwareIdList" key="softwareIdList">
          <el-select v-model="ruleForm.softwareIdList" placeholder="正确选择分类以便让用户了解您的资产信息" filterable multiple
            style="width: 550px">
            <el-option v-for="item in softwareIdList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="渲染器" prop="rendererIdList" key="rendererIdList">
          <el-select v-model="ruleForm.rendererIdList" placeholder="正确选择渲染器能给用户提供准确需求信息" filterable multiple
            style="width: 550px">
            <el-option v-for="item in rendererIdList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="版权" prop="copyright" key="copyright">
          <div class="inline-item">
            <el-select v-model="ruleForm.copyright" placeholder="请选择版权" style="width: 550px">
              <el-option v-for="item in copyright" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>

            <span>
              *请仔细阅读
              <el-popover placement="right" :width="400" trigger="click">
                <template #reference>
                  <a class="specification" :style="{ cursor: 'pointer' }">《版权说明》</a>
                </template>
                <div>
                  <p>
                    <br>免费
                    <br>版权不明确，仅限用于学习交流之用，不可用于商业用途。
                    <br>
                    <br>原创自制
                    <br>用户自行制作的资产，无版权等授权文件，不可用于商业用途，如被投诉侵权，则需要用户自行承担相应风险。
                    <br>
                    <br>商用授权
                    <br>用户上传的资产为原创且已经在版权局进行登记，选择此项务必上传相关文件，否则不予通过。
                    <br>
                    <br>CC0(免费可商用)版权共享协议。
                    <br>#创作者（设计师，摄影师等）自己把作品的版权共享给世界，不再持有版权。全世界范围内可以任意商用。
                    <br>#实际情况：由于各共享网站（CC0）上很多是非盈利，或者不承担法律监管责任，共享内容中夹杂了各种盗版内容、非法内容，所以共享网站上的内容更加适合非商业使用（比如学习、交流等）。商业用途，被告的概率非常大。
                  </p>
                </div>
              </el-popover>
            </span>
          </div>
        </el-form-item>

        <el-form-item label="版权证书" key="copyrightCertificate">
          <div class="copyright-box">
            <div v-if="copyLoading" class="copyUpload-mask"></div>

            <div style="display: inline-block; vertical-align: top">
              <el-upload class="upload-copyright" v-if="!copyrightCertificateFile.url" name="file"
                :disabled="!GET_USER_INFO.phone" :multiple="false" :action="UPLOAD_FILE_URL" :headers="uploadHeader"
                :show-file-list="true" :before-upload="beforehandleCopy" :on-exceed="copyrightImitFun"
                :on-success="handleCopyrightSuccess">
                <el-button size="small" type="danger" plain :loading="copyLoading" :disabled="!GET_USER_INFO.phone"
                  :title="GET_USER_INFO.phone ? '' : '【请先绑定手机】'">
                  {{ copyLoading ? "上传中" : "点击上传" }}
                </el-button>
              </el-upload>
            </div>

            <span v-if="copyrightCertificateFile.url">
              {{ copyrightCertificateFile.name }}
              &nbsp;
              <i class="el-icon-download" @click="downLoadCertificate()" style="cursor: pointer"></i>
              &nbsp;
              <i class="el-icon-delete" @click="handleCopyrightRemove" style="cursor: pointer"></i>
            </span>
          </div>
        </el-form-item>

        <el-form-item key="classVerify">
          <template slot="label">
            <span style="color: #f56c6c">*</span> 分类
          </template>
          <m-class ref="class" @callback="classCallBack" :addBeforeFun="classVerify" :maxSelected="10" />
          <div style="color: #c0c5cf">
            *正确选择软件格式能让用户精确搜索到您的模型 &nbsp; <span style="color: #fa5c5c">最多可选择10个分类</span>
          </div>
        </el-form-item>

        <el-form-item label="行业" prop="industryIdList" key="industryIdList">
          <el-select v-model="ruleForm.industryIdList" filterable multiple placeholder="请选择行业" style="width: 550px">
            <el-option v-for="item in industryIdList" :key="item.industryId" :label="item.name"
              :value="item.industryId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="labelIdList.length" label="活动" prop="labelIdList" key="labelIdList">
          <el-select v-model="ruleForm.labelIdList" filterable placeholder="请选择活动" style="width: 550px">
            <el-option v-for="item in labelIdList" :key="item.labelId" :label="item.name"
              :value="item.labelId"></el-option>
          </el-select>
        </el-form-item>

        <el-row>
          <el-col :span="6">
            <el-form-item label="价格" key="priceType">
              <el-select v-model="ruleForm.priceType" placeholder="请选择" style="width: 200px">
                <el-option key="0" label="免费" :value="0"></el-option>
                <el-option key="1" label="收费" :value="1"></el-option>
                <el-option key="2" label="积分" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="ruleForm.priceType == 1">
            <el-form-item label key="price" prop="price">

              <el-input v-model="ruleForm.price" placeholder="请填写搜点" style="width: 200px"></el-input>
              <span> 搜点（1搜点 = 1元）</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.priceType == 2">
            <el-form-item label key="price" prop="price">
              <el-input v-model="ruleForm.price" placeholder="请填写积分" style="width: 200px"></el-input>
              <span> 积分 </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="畅快用" key="isAuth">
          <el-checkbox v-model="ruleForm.isAuth" label="申请认证"></el-checkbox>
          <div style="width: 200px; font-size: 14px; padding: 0 0 0 0">
            *点击查看
            <el-popover placement="right" :width="400" trigger="click">
              <template #reference>
                <a class="specification" :style="{ cursor: 'pointer' }">《认证标准》</a>
              </template>
              <div>
                <p>
                  <b>畅快用认证标准</b><b></b>
                </p>
                <p>
                  <b>&nbsp;</b>
                </p>
                <p>
                  <span>畅快用是</span>CG搜模网针对高质量即下即用资产推出的认证。须达到以下要求才可提交申请，申请通过后，给予认证。
                </p>
                <p>
                  <br />
                </p>
                <p>
                  <span>认证标准：</span>
                </p>
                <p>
                  1.&nbsp;<span>严格遵守命名规范，文件名清晰明确。详情见《模型上传规范》</span>
                </p>
                <p>
                  2.&nbsp;<span>模型完好，导入即用。</span>
                </p>
                <p>
                  3.&nbsp;<span>导出至少</span>3种格式（obj、fbx、制作软件格式）
                </p>
                <p>
                  4.&nbsp;<span>分类选择清晰</span>
                </p>
                <p>
                  5.&nbsp;<span>用户的原创模型</span>
                </p>
              </div>
            </el-popover>
          </div>
        </el-form-item>

        <el-form-item label key="protocol">
          <el-checkbox label v-model="ruleForm.protocol"></el-checkbox>
          我已阅读且同意

          <a class="specification" :style="{ cursor: 'pointer' }" @click="dialogTableVisible = true">《用户发布内容规范》</a>
        </el-form-item>

        <el-form-item>
          <el-button v-if="ruleForm.protocol" type="primary" @click="submitForm(2)">发布资产</el-button>
          <el-button v-else type="info">发布资产</el-button>
          <el-button @click="submitForm(1)">保存草稿箱</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-dialog width="1000" :visible.sync="dialogTableVisible" title="请您仔细阅读以下内容" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="protocol-home">
        <div>
          <iframe src="/protocol/modelUploadSpecification.html" frameborder="0" class="protocolPrivacy"></iframe>
        </div>
      </div>
      <div class="closeButton">

        <el-button type="primary" @click="agreeProtocol">我已阅读并同意以上规范 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 分片上传
// vue-simple-uploader
// https://www.npmjs.com/package/vue-simple-uploader

// 上传组件
// https://github.com/lian-yue/vue-upload-component
// https://github.com/simple-uploader/vue-uploader/blob/master/README_zh-CN.
import draggable from "vuedraggable";
import { mapGetters, mapMutations } from "vuex";
import { Message } from "element-ui";
import MClass from "@/components/mClass";
import {
  saveDraftBoxApi,
  mapListApi,
  resourceAddApi,
  resourceDetailTokenApi,
  resourceChangeApi,
  labelListApi,
  industryListApi,
  classIdApi,
  mediaSetApi,
  downLoadUrlApi,
  downLoadApi,
  uplaodImageWaterApi
} from "@/api/resource";
import request from "@/utils/request";
import { myAccountApi } from "@/api/user";
import {
  UPLOAD_URL_WATER,
  UPLOAD_URL,
  UPLOAD_FILE_URL,
  EDITOR_UPLOAD_IMAGE,
} from "@/utils/variable";
import commonMixin from "@/mixins/commonMixin";
import E from "wangeditor";
import ImgCutter from '@/components/ImgCutter';
export default {
  name: 'resource',
  mixins: [commonMixin],

  beforeRouteLeave (to, from, next) {
    let path = '/user/resource/edit/7432'
    let editpath = path.slice(0, 19) // 从编辑页过来

    if (this.SET_CHANGERULES_STATE === true && this.isContent === false && (from.path).slice(0, 19) !== editpath) {

      setTimeout(() => {
        this.$confirm('如果此页面有资源未保存，请您保存至草稿箱后再离开。否则资源将丢失！', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (from.path == '/user/resource') {
            next()
            location.reload()
          }

        }).catch(() => {
        })
      }, 1)
    } else {
      next()
    }


  },
  data () {
    let checkPrice = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error('数字大于0'));
      } else {
        callback();
      }
    };
    return {
      visibleTemp: false,
      id: "",
      pageType: "",
      UPLOAD_URL_WATER,
      UPLOAD_URL,
      UPLOAD_FILE_URL,
      imgLoading: false,
      //检测鼠标悬停
      titleHover: false,
      //对话框状态
      dialogTableVisible: false,
      // 上传多张图片
      uploadImgCount: 0,
      headImageLoading: false,
      uploadHeadImgCount: 0,

      mediaSetObj: {},
      industryIdList: [],
      includeIdList: [],
      softwareIdList: [],
      rendererIdList: [],
      copyright: [],
      labelIdList: [],
      uploadHeader: {},
      fileLoading: false,
      copyLoading: false,
      ruleForm: {
        uploadType: "1",
        title: "",
        price: 1,
        priceType: 0,
        netDisk: "",
        netDiskCode: "",
        copyright: "",
        pointNum: undefined,
        surfaceNum: undefined,
        remark: "",
        copyrightCertificate: "",
        includeIdList: [],
        labelIdList: 0,
        classifyIdList: [],
        industryIdList: [],
        softwareIdList: [],
        rendererIdList: [],
        fileList: [],
        isAuth: false,
        protocol: false,
        imageList: [],
        headImageList: []
      },
      rules: {
        uploadType: [
          {
            required: true,
            message: "请选择上传方式",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入标题",
          },
          {
            min: 1,
            max: 32,
            message: "最大长度32",
          },
        ],
        surfaceNum: [
          {
            required: true,
            message: "请输入数字",
            trigger: "blur",
          },

        ],
        includeIdList: [
          {
            required: true,
            message: "请选择包含属性",
          },
        ],
        softwareIdList: [
          {
            required: true,
            message: "请选择软件",
          },
        ],
        rendererIdList: [
          {
            required: true,
            message: "请选择渲染器",
          },
        ],
        copyright: [
          {
            required: true,
            message: "请选择版权",
          },
        ],
        industryIdList: [
          {
            required: true,
            message: "请选择行业",
          },
        ],
        labelIdList: [
          {
            required: true,
            message: "请选择标签",
          },
        ],
        price: [
          {
            required: true,
            message: "请填写价格",
            trigger: "blur",
          },
          {
            pattern: /^([0-9]+[\d]*(.[0-9]{1,2})?)$/,
            message: "数字保留两位小数",
          },
          { validator: checkPrice, trigger: 'blur' }
        ],
      },
      // 富文本编辑器
      contentEditor: null,
      fileFlag: true,
      isContent: false,
      fileId: null,
      fileObj: {}
    };
  },
  created () {

    /* 资产编辑、资产详情共用页面 */
    /* edit、detail */
    const {
      params: { id, type },
    } = this.$route;

    if (type) {
      this.pageType = type;
    }

    if (id) {
      this.id = id;
    }

    this.uploadHeader = {
      token: this.GET_USER_INFO.token,
    };
    this.getMedia();
    // 点击编辑-回显详情
    this.getDetail();
  },
  watch: {
    $route (to, from) {

      location.reload();
    },
    ruleForm: {
      handler (newval, oldval) {
        if (oldval) {
          this.$store.commit('SET_CHANGERULES_STATE', true)
        }
      },
      immediate: true,
      deep: true
    }
  },
  // 销毁
  beforeDestroy () {
    // 销毁富文本编辑器
    if (this.contentEditor) {
      this.contentEditor.destroy();
      this.contentEditor = null;
    }
  },

  mounted () {
    let _this = this;
    window.onbeforeunload = function (e) {
      if (_this.$route.name == "resource") {
        // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
        return "";
      } else {
        window.onbeforeunload = null;
      }
    };
  },
  computed: {
    ...mapGetters(["GET_USER_INFO", "SET_CHANGERULES_STATE"]),
    copyrightCertificateFile () {
      if (this.ruleForm.copyrightCertificate) {
        return {
          name: "版权证书",
          url: this.ruleForm.copyrightCertificate,
        };
      }
      return {};
    },
  },
  methods: {

    ...mapMutations({
      SET_USER_INFO: "SET_USER_INFO",
    }),
    cutDown (fileTarget) {
      let file = this.dataURLtoBlob(fileTarget.dataURL, fileTarget.fileName)
      let formData = new FormData()
      formData.append('image', file)
      uplaodImageWaterApi(formData).then(res => {
        this.handleHeadImageSuccess(res)
      })
    },
    //将base64转换为file
    dataURLtoBlob: function (dataurl, name) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], name, { type: mime })
    },
    getMedia () {
      mediaSetApi()
        .then((res) => {
          if (res.code == 200) {
            this.mediaSetObj = res.data;
            this.getAccount();
          }
        })
        .catch((err) => {
          this.getAccount();
        });
    },
    getAccount () {
      myAccountApi().then((res) => {
        if (res.code == 200) {
          let accountInfo = res.data;
          const { initUserAvatarUrl = "", initUserBackGroundUrl = "" } =
            this.mediaSetObj;

          if (!accountInfo.headImgUrl) {
            accountInfo.headImgUrl = initUserAvatarUrl ? initUserAvatarUrl : "";
          }

          if (!accountInfo.backgroundImgUrl) {
            accountInfo.backgroundImgUrl = initUserBackGroundUrl
              ? initUserBackGroundUrl
              : "";
          }

          this.SET_USER_INFO(accountInfo);
        }
      });
    },
    // 对话框
    agreeProtocol () {
      if (this.dialogTableVisible) {
        this.dialogTableVisible = false;
        this.ruleForm.protocol = true;
      } else {
        this.dialogTableVisible = false;
      }
    },
    /**
     * 点击编辑 - 回显详情
     */
    getDetail () {
      if (this.id) {
        resourceDetailTokenApi(this.id).then((res) => {
          if (res.code == 200) {
            let obj = res.data;
            /**
            *  上传方式
            */
            if (obj.netDisk) {
              obj.uploadType = "2";
            } else {
              obj.uploadType = "1";
            }


            /* 转换数据类型 -- 版权 */
            if (obj.copyright) {
              obj.copyright = parseInt(obj.copyright);
            }

            /**
             * 活动
             */
            if (obj.labelIdList.length) {
              obj.labelIdList = obj.labelIdList[0];
            } else {
              obj.labelIdList = 0;
            }

            /* 判断价格 免费or收费or积分 */
            if ((obj.priceType == 0 && obj.price == 0) || obj.priceType == 3) { // 免费
              obj.priceType = 0;
            } else if (obj.priceType == 1 && obj.price != 0) { // 搜币
              obj.priceType = 1;
            } else if ((obj.priceType == 0 && obj.price != 0) || obj.priceType == 2) {
              obj.priceType = 2;
            }


            // 畅快用
            if (obj.isAuth) {
              obj.isAuth = true;
            } else {
              obj.isAuth = false;
            }

            // 分割 首图 和 预览图
            if (obj.imageList[0]) {
              obj.headImageList = [obj.imageList[0]];
              obj.imageList.splice(0, 1);
            }


            this.ruleForm = obj;


            //富文本
            setTimeout(() => {
              //富文本
              let contentEditor = this.createEditor(
                this.$refs.contentEditor,
                obj.remark
              );
              this.contentEditor = contentEditor;
            }, 100);

            this.getInitSelect();
          }
        });
      } else {
        //富文本
        setTimeout(() => {
          //富文本
          let contentEditor = this.createEditor(this.$refs.contentEditor, "");
          this.contentEditor = contentEditor;
        }, 100);

        this.getInitSelect();
      }

    },
    getInitSelect () {
      this.getIndustry();
      this.getIncludeList();
      this.getSoftList();
      this.getRenderList();
      this.getCopyrightList();
      this.getLabel();
      this.getClass();
    },
    /* 获取分类 */
    getClass () {
      const { classifyIdList = [] } = this.ruleForm;
      const arr = classifyIdList.map((item) => classIdApi(item));

      // 多选情况下的默认数据选择
      let multipleSelectData = [];
      Promise.all(arr).then((res) => {
        let arr = [];

        res.forEach((item) => {
          if (item.code == 200) {
            arr.push(item.data);
          }
        });

        this.$refs.class.setTags(
          arr.map((item) => ({
            ...item,
            categoryId: item.categoryId,
            categoryName: item.categoryName,
          }))
        );

        async function pushParentClass (arr) {
          let firstClass = arr[0].split("_")[1];

          let responseClassInfo = await classIdApi(firstClass);
          const { data: responseData } = responseClassInfo;

          if (responseData.parentId > 1) {
            arr.unshift("0_" + responseData.parentId);
            await pushParentClass(arr);
          } else {
            arr.unshift(responseData.type + "_1");
          }
        }
        arr.map(async (item) => {
          let multipleSelectData = [];
          multipleSelectData.push("0_" + item.categoryId);
          await pushParentClass(multipleSelectData);

          this.$refs.class.addSelectedValue(multipleSelectData);
        });
      });
    },
    classCallBack (value = []) {
      const classifyIdList = value.map((item) => item.categoryId);
      this.$set(this.ruleForm, "classifyIdList", classifyIdList);
    },
    classVerify (arr) {
      if (arr.length >= 5) {
        this.$message.error("最多添加5个分类");
        return false;
      }

      return true;
    },
    /* 获取已选行业 */
    getIndustry () {
      const params = {
        name: "",
        pageNum: 1,
        pageSize: 9999,
      };

      industryListApi(params).then((res) => {
        if (res.code == 200) {
          const { list = [] } = res.data;
          this.industryIdList = list;
        }
      });
    },
    getIncludeList () {
      const params = {
        type: 5,
      };

      mapListApi(params).then((res) => {
        if (res.code == 200) {
          this.includeIdList = res.data;
        }
      });
    },
    getSoftList () {
      const params = {
        type: 2,
      };

      mapListApi(params).then((res) => {
        if (res.code == 200) {
          this.softwareIdList = res.data;
        }
      });
    },
    getRenderList () {
      const params = {
        type: 4,
      };

      mapListApi(params).then((res) => {
        if (res.code == 200) {
          this.rendererIdList = res.data;
        }
      });
    },
    getCopyrightList () {
      const params = {
        type: 6,
      };

      mapListApi(params).then((res) => {
        if (res.code == 200) {
          this.copyright = res.data;
        }
      });
    },
    getLabel () {
      const params = {
        name: "",
        pageNum: 1,
        pageSize: 9999,
      };

      labelListApi(params).then((res) => {
        if (res.code == 200) {
          const { list = [] } = res.data;
          this.labelIdList = [
            {
              name: "不参与活动",
              labelId: 0,
            },
            ...list,
          ];
        }
      });
    },
    handleAvatarExceed () {
      Message({
        message: "文件超出超出个数!最多选择24个",
        type: "error",
        duration: 5 * 1000,
      });
    },
    handleAvatarSuccess (res) {
      this.uploadImgCount--;
      if (this.uploadImgCount < 1) {
        this.imgLoading = false;
      }



      if (res.code !== 200) {
        Message({
          message: res.message || "错误",
          type: "error",
          duration: 5 * 1000,
        });
      } else {
        this.$set(this.ruleForm, "imageList", [
          ...this.ruleForm.imageList,
          res.data,
        ]);
      }
    },

    beforeHeadImageUpload (file) {
      var isSize;
      var isLt2M;
      isLt2M = file.size / 1024 < 200;
      if (!isLt2M) {
        this.$message({
          message: "首图大小不能超过200kb!",
          type: "error",
        });
        return false;
      }
      isSize = new Promise((resolve, reject) => {
        const width = 800;
        const height = 800;
        const _URL = window.URL || window.webkitURL;
        const img = new Image();
        img.onload = () => {
          const valid = img.width === img.height && img.width >= 500 && img.height >= 500 && img.width <= 800 && img.height <= 800
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          if (isSize) {
            this.uploadHeadImgCount++;
            this.headImageLoading = true;
          }
          return file;
        },
        () => {
          this.$message.error("首图尺寸限制为大于500*500，小于800*800的正方形图片");
          return Promise.reject();
        }
      );


      return isLt2M && isSize;
    },

    handleHeadImageSuccess (res) {
      this.uploadImgCount--;
      if (this.uploadImgCount < 1) {
        this.headImageLoading = false;
      }

      if (res.code !== 200) {
        Message({
          message: res.message || "错误",
          type: "error",
          duration: 5 * 1000,
        });
      } else {
        this.$set(this.ruleForm, "headImageList", [
          res.data,
        ]);
      }
    },


    /**
     * 
     * @desc 删除首图 
     */
    handleHeadImgRemove (file) {

      let imageList = this.ruleForm.headImageList.filter(item => {
        if (item.imageId) {
          item.imageId != file.imageId
        }

      }

      );
      this.$set(this.ruleForm, "headImageList", imageList);
    },

    beforeAvatarUpload (file) {
      var isLt2M;
      isLt2M = file.size / 1024 < 1000;
      if (!isLt2M) {
        this.$message({
          message: "其它图大小不能超过1MB!",
          type: "error",
        });
        return false;
      }
      return isLt2M
    },

    /**
     * 
     * @@desc 删除预览图
     */
    handleImgRemove (file) {
      const { imageList } = this.ruleForm
      let imgList = imageList.filter(item => {
        return item.imageId !== file.imageId
      })
      this.$set(this.ruleForm, "imageList", imgList);
    },

    /**
     * @desc 上传文件之前的钩子 
     */
    beforeFileUpload (file) {

      let flag = true;
      let { mediaFormat = "", mediaSize = 0 } = this.mediaSetObj;
      // 文件大小判断
      if (mediaSize > 0) {
        mediaSize = mediaSize * 1024 * 1024;
        if (file.size > mediaSize) {
          this.$message.error("超出文件上传最大限制，请上传小于2048M的文件");
          flag = false;
        }
      }
      // 文件后缀判断name
      if (mediaFormat) {
        let fileName = file.name;
        let lastIndex = fileName.lastIndexOf(".");
        let typeArr = [];

        mediaFormat = mediaFormat.split(",");
        typeArr = typeArr.concat(mediaFormat);

        fileName = fileName.slice(lastIndex).toLocaleLowerCase();

        const index = typeArr.findIndex((item) => {
          return item === fileName;
        });

        if (index == -1) {
          this.$message.error("文件格式不允许");
          flag = false;
        }
      }

      if (flag) {
        this.fileLoading = true;
      }
      return flag;
    },

    /**
     * @desc 移除文件之前的钩子
     */
    beforeFileRemove (file, fileList) {
      //console.log(file,'ooo'); console.log(fileList,'6666');
      //  if(val.percentage !== '100' && ){

      //  }
      this.fileLoading = false;
      this.fileFlag = false
    },
    /**
     * 
     * @desc 移除文件的钩子
     */
    async handleFileRemove (val) {
      const { fileList } = this.ruleForm;
      let fileData = fileList.filter(item => {
        return item.fileId !== val.fileId
      })
      this.$set(this.ruleForm, "fileList", fileData);
    },

    /**
     * @desc 上传文件的请求
     */
    handleFileSuccess (fileObj) {
      fileObj.status = 'uploading'
      fileObj.percentage = 0

      this.fileObj = fileObj.file
      let formData = new FormData()
      formData.append('file', this.fileObj)
      request({
        url: `/common/uplaod/file`,
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: function (progressEvent) {
          // 处理上传进度事件，在这里改变percentage的值吧
          let percent = (progressEvent.loaded / progressEvent.total * 100).toFixed(0);   //计算出上传的进度，去整数位

          fileObj.onProgress({ percent: percent })  //动态设置fileObj的percentage
        },
        data: formData,
      }).then(res => {

        this.fileLoading = false;
        if (res.code !== 200) {
          fileObj.status = 'failed';
          fileObj.message = '上传失败';
          Message({
            message: res.message || "错误",
            type: "error",
            duration: 5 * 1000,
          });
        } else {

          fileObj.status = 'success';
          res.data.status = 'success'
          res.data.percentage = 100
          this.fileId = res.data.fileId

          this.$set(this.ruleForm, "fileList", [
            ...this.ruleForm.fileList,
            res.data,
          ]);
        }
      })
    },

    handleFileProgress (event, file, fileList) {

      if (file === undefined) {

      }
    },

    downLoad (file) {
      let fileId = file.fileId;
      downLoadUrlApi({
        fileId,
      }).then((res) => {
        if (res.code == 200) {
          const url = res.data;
          const link = document.createElement("a");
          const { flag: bowerCanDown, fileName: txtName } =
            this.isBowerCanDown(url);

          if (bowerCanDown) {
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", txtName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            this.oldDownLoad(fileId, txtName);
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    downLoadCertificate () {
      let file = {
        fileId: this.ruleForm.copyrightCertificate,
      };
      this.downLoad(file);
    },
    handleCopyrightRemove (file) {
      this.$set(this.ruleForm, "copyrightCertificate", "");
    },
    handleCopyrightSuccess (res) {
      this.copyLoading = false;
      if (res.code !== 200) {
        Message({
          message: res.message || "错误",
          type: "error",
          duration: 5 * 1000,
        });
      } else {
        this.$set(this.ruleForm, "copyrightCertificate", res.data.fileId);
      }
    },
    copyrightImitFun () {
      Message({
        message: "文件超出超出个数",
        type: "error",
        duration: 5 * 1000,
      });
    },
    beforehandleCopy (file) {
      let flag = false;
      const isImg = ["image/jpeg", "image/png", "application/pdf"].includes(
        file.type
      );

      if (this.ruleForm.copyrightCertificate) {
        this.$message.error("最多只能上传一个文件");
        return false;
      }

      if (!isImg) {
        this.$message.error("文件格式不允许");
      }

      flag = isImg;

      if (flag) {
        this.copyLoading = true;
      }

      return flag;
    },
    /**
     * 
     * @desc 发布资产/保存到我的草稿箱
     */
    submitForm (status) {

      if (this.SET_CHANGERULES_STATE) { // true 用户编辑 ，false 用户没有编辑
        this.isContent = true
      }
      this.$store.commit('SET_BTN_TYPE', status) // 在我的资产中判断点击的是发布资产按钮 还是草稿箱按钮

      if (status === 2) { //发布资产

        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            let API = "";
            this.ruleForm.classifyIdList = this.ruleForm.classifyIdList.splice(0, 10)
            let params = {
              ...this.ruleForm,
              status,
              remark: this.contentEditor.txt.html(),
            };
            const {
              fileList = [],
              imageList = [],
              headImageList = [],
              uploadType,
              isAuth,
            } = this.ruleForm;

            if (uploadType == 1) {
              if (!fileList.length) {
                this.$message.error("请上传资产文件");
                return false;
              }

              params.netDisk = "";
              params.netDiskCode = "";
              if (fileList) {
                params.fileIdList = fileList.map((item) => item.fileId);
              }

            } else if (uploadType == 2) {
              params.fileIdList = [];
            }

            /* 如果用户选择版权局登记，则必须上传版权证书 */
            if (params.copyright == 97 && !params.copyrightCertificate) {
              this.$message.error("请上传版权证书");
              return false;
            }

            if (!headImageList.length) {
              this.$message.error("请上传首图");
              return false;
            }

            if (!imageList.length) {
              this.$message.error("请上传预览图");
              return false;
            }

            /* 如果是免费模型 */
            if (params.priceType == 0) {
              params.price = 0;
            }

            if (params.priceType == 1 && params.price == 0) {
              this.$message.error("请填写价格");
              return false;
            }
            if (params.priceType == 2 && params.price == 0) {
              this.$message.error("请填写积分");
              return false;
            }


            /* 分类 */
            if (!params.classifyIdList.length) {
              this.$message.error("请添加分类");
              return false;
            }

            /* 如果是活动 */
            if (params.labelIdList) {
              params.labelIdList = [params.labelIdList];
            } else {
              params.labelIdList = [];
            }

            params.imageIdList = headImageList.map(item => item.imageId).concat(imageList.map((item) => item.imageId));
            params.isAuth = +isAuth;

            if (this.id) {

              params.assetsId = this.id;

              API = resourceChangeApi;
            } else {
              API = resourceAddApi;
            }


            // 点击我的资产 
            API(params).then((res) => {

              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "已保存到我的资产!",
                });
                this.$store.commit('SET_CHANGERULES_STATE', false)
                this.$router.push({ path: "/user/myAssets" });
              }
            });


          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else if (status === 1) { // 点击我的草稿箱

        if (this.isContent) {
          this.$store.commit('SET_CHANGERULES_STATE', false)

          // ----------
          let API = "";
          this.ruleForm.classifyIdList = this.ruleForm.classifyIdList.splice(0, 10)
          let params = {
            ...this.ruleForm,
            status,
            remark: this.contentEditor.txt.html(),
          };
          const {
            fileList = [],
            imageList = [],
            headImageList = [],
            uploadType,
            isAuth,
          } = this.ruleForm;

          // 上传资产文件
          if (uploadType == 1) {
            params.netDisk = "";
            params.netDiskCode = "";
            params.fileIdList = fileList.map((item) => item.fileId);
          } else if (uploadType == 2) {
            params.fileIdList = [];
          }

          /* 如果是免费模型 */
          if (params.priceType == 0) {
            params.price = 0;
          }



          /* 活动 */
          if (params.labelIdList) {
            params.labelIdList = [params.labelIdList];
          } else {
            params.labelIdList = [];
          }

          params.imageIdList = headImageList.map(item => item.imageId).concat(imageList.map((item) => item.imageId));
          params.isAuth = +isAuth;

          if (this.id) {

            params.assetsId = this.id;

            API = resourceChangeApi;
          } else {
            API = resourceAddApi;
          }


          // 点击我的资产 
          API(params).then((res) => {

            if (res.code == 200) {
              this.$store.commit('SET_CHANGERULES_STATE', false)
            }
          });


          // 我的草稿箱接口
          let saveParam = {
            pageNum: 1,
            pageSize: 15
          }
          saveDraftBoxApi(saveParam).then(res => {

            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "已保存到我的草稿箱!",
                offset: 350
              });
              this.$store.commit('SET_CHANGERULES_STATE', false)
              this.$router.push({ path: "/user/myAssets" });
            }
          })

        } else {
          this.$message({
            type: 'info',
            message: '没有要保存的资源'

          });
        }
      }
    },
    isBowerCanDown (url) {
      let flag = true;
      const filter = /\.(png|jpg|gif|jpeg|webp)$/i;
      const queryIndex = url.indexOf("?");
      const path = url.slice(0, queryIndex);
      const fileIndex = path.lastIndexOf("\/");
      const fileName = decodeURIComponent(path.slice(fileIndex + 1));

      if (fileName && filter.test(fileName)) {
        flag = false;
      }

      return {
        fileName,
        flag,
      };
    },
    oldDownLoad (fileId, filename) {
      downLoadApi({
        fileId,
      }).then((res) => {
        // 假设 data 是返回来的二进制数据
        const data = res.data;
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");

        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },

    // ->富文本
    //创建富文本
    createEditor (ref, content) {
      let placeholder =
        "描述推荐示例：</br>" +
        "【软件】：3DS Max 2022</br>" +
        "【渲染器】：VRAY 5.1</br>" +
        "【格式】：OBJ、FBX</br>" +
        "【是否有动画】：无</br>" +
        "【是否有绑定】：无</br>" +
        "【是否有UV】：无</br>" +
        "【是否有贴图纹理】：有</br>" +
        "【场景是否使用插件】：无</br>" +
        "【制作介绍】：</br>" +
        "模型完全自己制作，制作周期为一周，因为在上学，所以模型只能在闲暇时间慢慢制作，这是我制作室内系列的第一个模型，后续可能还会制作更新更多模型，希望喜欢的小伙伴多多留言，也可以留言给我需要的模型，我会考虑制作哒~";

      const that = this;
      //富文本
      let editor = new E(ref);
      editor.config.zIndex = 800;
      editor.config.height = 350;
      editor.config.placeholder = placeholder;
      // 配置菜单栏，设置不需要的菜单
      editor.config.excludeMenus = ["video"];

      // header
      editor.config.uploadImgHeaders = this.uploadHeader;
      // fileName
      editor.config.uploadFileName = "image";
      //本地图片上传配置
      editor.config.uploadImgServer = EDITOR_UPLOAD_IMAGE;
      // 上传图片回调函数
      editor.config.uploadImgHooks = {
        // 图片上传并返回了结果
        customInsert: function (insertImgFn, res) {
          // 成功
          if (res.code == 200) {
            // insertImgFn函数
            insertImgFn(that.linkAllImgUrl(res.data.url));
          } else {
            alert("图片上传错误。");
          }
        },
      };

      //创建富文本
      editor.create();

      // 存在初始化
      if (content) {
        //初始化内容
        editor.txt.html(content);
      }

      //返回富文本对象
      return editor;
    },

    // 销毁编辑器
    editorDestroy () {
      if (this.contentEditor) {
        this.contentEditor.destroy();
        this.contentEditor = null;
      }
    },

    onDragStart (e) {
      e.target.classList.add("hideShadow");
    },
    onDragEnd (e) {
      e.target.classList.remove("hideShadow");
    },

  },
  components: {
    MClass,
    draggable,
    ImgCutter
  },
};
</script>

<style lang="less" scoped>
.commonDisblock() {
  display: inline-block;
  vertical-align: top;
}

/deep/ .el-cascader__tags {
  max-height: 56px !important;
  overflow: hidden;
}

.box-card {
  margin-bottom: 10px;
  border: none;
}

.upload-file-tip {
  font-size: 14px;
  padding: 10px 0;
  color: red;
}

.mUpload-box {
  position: relative;

  .mUpload-mask {
    position: absolute;
    left: 0;
    top: 4px;
    width: 82px;
    height: 34px;
    opacity: 0;

  }
}

.copyright-box {
  position: relative;

  .copyUpload-mask {
    position: absolute;
    left: 0;
    top: 4px;
    width: 82px;
    height: 34px;
    opacity: 0;
  }
}

.inline-item {
  .commonDisblock();
  margin-right: 10px;
}

.m-row-l {
  width: 60px;
  .commonDisblock();
}

.m-row-r {
  .commonDisblock();
}

.img-list {
  display: inline-block;
  vertical-align: top;

  .img-item {
    overflow: hidden;
    position: relative;
    display: inline-block;
    vertical-align: top;
    margin: 0 10px 10px 0;
    width: 148px;
    height: 148px;
    border-radius: 6px;

    img {
      width: 100%;
      height: 100%;
    }

    .el-upload-list__item-actions {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      cursor: default;
      text-align: center;
      color: #fff;
      opacity: 0;
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s;
    }

    .el-upload-list__item-delete {
      display: inline-block;
      position: static;
      font-size: inherit;
      color: inherit;
      right: 10px;
      top: 0;
      margin-top: 57px;
      cursor: pointer;
    }

    &:hover {
      .el-upload-list__item-actions {
        opacity: 1;
      }
    }
  }
}

.img-container {
  display: inline-block;
  vertical-align: top;
  width: 148px;
  height: 148px;
}

.image-box {
  display: inline-block;
  text-align: center;
  cursor: pointer;
  outline: 0;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  line-height: 146px;
  vertical-align: top;

  i {
    font-size: 28px;
    color: #8c939d;
    font-family: element-icons !important;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    vertical-align: baseline;
    display: inline-block;
    -webkit-font-smoothing: antialiased;
  }
}

.base-info {
  padding: 0 10px;
  color: #409eff;
  font-size: 12px;
  line-height: 24px;
}

// 拖拽
.vue-draggable {
  display: flex;
  flex-wrap: wrap;

  &.hideShadow {
    .shadow {
      display: none;
    }
  }

  &.single {
    overflow: hidden;
    position: relative;
  }

  &.maxHidden {
    .uploadBox {
      display: none;
    }
  }
}

//用户协议规范
.protocolPrivacy {
  width: 920px;
  height: 500px;
}

.protocol-home {
  width: 920px;
  height: 560px;
}

.closeButton {
  position: relative;
  // bottom: 15px;
  top: 15px;
  left: 35%;
  margin: auto;
}

.user-resource-inputNum {
  .el-input .el-input__inner {
    text-align: left;
  }
}

/deep/ .el-cascader-menu__wrap {
  height: auto;
  max-height: 400px;
}

.specification {
  color: red;
}

.copyright a {
  color: transparent !important;
  text-decoration: none !important;
  position: relative !important;
  opacity: 1 !important;
  display: inline-block !important;
  padding: 2px !important;
  background: rgba(0, 0, 0, 0.4);
}
</style>
